import { ThemeOptions } from '@mui/material';

export const codeActionsTheme: ThemeOptions['components'] = {
  DsCodeActions: {
    styleOverrides: {
      root: {
        display: 'flex',
        flexDirection: 'row',
        position: 'absolute',
        top: 15,
        right: 20,
        zIndex: 1,
      },
      sizeMd: {
        '& svg': {
          fontSize: 16,
        },
      },
      sizeLg: {
        '& svg': {
          fontSize: 20,
        },
      },
    },
  },
};
